import { Loader, PageHeader } from '@paytrace/pt-skel/Component'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import Event from '../../Event'
import { defaultNetworkErrorHandler } from '../../Helper/util'

export interface TemplateProps {
  title: string
  redirectUrl: string
  helpUrl?: string
  symbol: Symbol
  responseMessage?: string
  errorMessage?: string
  networkErrorHandler?: (error: Error) => void
}

export function EnhancedDataPageTemplate (prop: PropsWithChildren<TemplateProps>): React.JSX.Element {
  const {
    networkErrorHandler = defaultNetworkErrorHandler,
    symbol,
    children,
    ...headerProps
  } = prop

  const [loadingCount, setLoadingCount] = useState(0)
  const isLoading: boolean = loadingCount > 0

  useEffect(() => {
    PubSub.sub(symbol, Event.DONE_LOADING, () => setLoadingCount(prev => Math.max(0, prev - 1)))
    PubSub.sub(symbol, Event.SOMETHING_LOADING, () => setLoadingCount(prev => prev + 1))

    PubSub.sub(symbol, Event.NETWORK_ERROR, (error: Error) => {
      console.debug(error)
      setLoadingCount(0)
      networkErrorHandler(error)
    })

    return () => PubSub.unsub(symbol)
  }, [symbol, networkErrorHandler])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className='ed-page'>
      <PageHeader {...headerProps}/>
      <div className='horizontal-break' />
      <div className='ed-container'>
        {children}
      </div>
    </div>
  )
}
